import { gql } from '@apollo/client';

const SIGN_UP = gql`
  mutation Signup($user: CreateUserInput!) {
    signup(user: $user) {
      id
      username
      name
      lastName
      conditions
      dataPolicy
      communicationsPolicy
      active
      activatedAt
      createdAt
      updatedAt
      legacyContext {
        monavisId
        sazId
      }
    }
  }
`;

export default SIGN_UP;
